module.exports = __webpack_public_path__ + "assets/images/lectura_math.e60154cd6a62f883c5e3d140df25b11c.svg";